import pdfMake from 'pdfmake/build/pdfmake'
import { useState } from 'react'
import { Col, Container, Form, Row, Table } from 'react-bootstrap'
import { DatabaseFillGear, FileEarmarkPdfFill } from 'react-bootstrap-icons'
import { CustomButton } from '../../../../components/CustomButton'
import { CustomInputDate } from '../../../../components/CustomInputDate'
import { useOrdenation } from '../../../../hooks/useOrdenation'
import WmsRelatorioService from '../../../../services/database/WmsRelatorioService'
import { formatDate } from '../../../../utils/formatDate'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'

pdfMake.fonts = {
  Roboto: {
    normal:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Medium.ttf',
    italics:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-MediumItalic.ttf',
  },
}

export function Produtividade() {
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [data, setData] = useState([])
  const [isRequestLoading, setIsRequestLoading] = useState(false)

  const { filteredItems, Th, Paginate, itemsPerPage, setItemsPerPage } =
    useOrdenation(data, 'rua', 'desc', '25')

  async function handleGetData() {
    try {
      setIsRequestLoading(true)

      const response = await WmsRelatorioService.produtividade(
        startDate,
        endDate,
      )

      setData(response)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar informações')
    } finally {
      setIsRequestLoading(false)
    }
  }

  function handleGeneratePDF(dados) {
    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 60, 40, 60],
      pageOrientation: 'landscape',

      content: [
        {
          text: 'Relatório de Produtividade',
          style: 'header',
          alignment: 'center',
          margin: [0, 0, 0, 5],
        },
        {
          text: `Gerado em ${new Date().toLocaleDateString('pt-BR')} às ${new Date().toLocaleTimeString('pt-BR')}`,
          style: 'subheader',
          alignment: 'center',
          margin: [0, 0, 0, 30],
        },
        {
          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*', '*', '*', '*'],
            body: [
              [
                { text: 'Data', style: 'tableHeader' },
                { text: 'Cód. Func.', style: 'tableHeader' },
                { text: 'Nome. Func.', style: 'tableHeader' },
                { text: 'Total OS', style: 'tableHeader' },
                { text: 'Total Produtos', style: 'tableHeader' },
                { text: 'Total Qtde', style: 'tableHeader' },
                { text: 'Tipo OS', style: 'tableHeader' },
              ],
              ...dados.map((item) => [
                { text: formatDate(item.data), style: 'tableCell' },
                {
                  text: item.cod_func_os,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.nomefuncionario,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.total_os,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.total_produtos,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.total_qtde,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.tipoos,
                  style: 'tableCell',
                  alignment: 'center',
                },
              ]),
            ],
          },
          layout: {
            fillColor: function (rowIndex) {
              return rowIndex === 0
                ? '#667eea'
                : rowIndex % 2 === 0
                  ? '#f8f9fa'
                  : null
            },
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? 1
                : 0.5
            },
            vLineWidth: function () {
              return 0
            },
            hLineColor: function (i) {
              return i === 0 || i === 1 ? '#667eea' : '#e0e0e0'
            },
          },
        },
        {
          text: `Total de registros: ${dados.length}`,
          style: 'footer',
          margin: [0, 20, 0, 0],
        },
      ],

      styles: {
        header: {
          fontSize: 22,
          bold: true,
          color: '#333',
        },
        subheader: {
          fontSize: 11,
          color: '#666',
        },
        tableHeader: {
          fontSize: 10,
          bold: true,
          color: '#ffffff',
          fillColor: '#667eea',
        },
        tableCell: {
          fontSize: 9,
          color: '#333',
        },
        footer: {
          fontSize: 10,
          italics: true,
          color: '#666',
          alignment: 'right',
        },
      },
    }

    pdfMake.createPdf(docDefinition).open()
  }

  return (
    <Container>
      <h1>Produtividade</h1>

      <Row className="mb-3">
        <Col xs={2}>
          <Form.Label>Data Inicial</Form.Label>

          <CustomInputDate
            selected={startDate}
            onChange={setStartDate}
          />
        </Col>

        <Col xs={2}>
          <Form.Label>Data Final</Form.Label>

          <CustomInputDate
            selected={endDate}
            onChange={setEndDate}
          />
        </Col>

        <Col xs={2}>
          <Form.Label>Items p. pág</Form.Label>
          <Form.Select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Form.Select>
        </Col>
      </Row>

      <Row>
        <div
          style={{
            width: '100%',
            display: 'flex',
            gap: 5,
          }}
        >
          <CustomButton
            noMargin
            title="Gerar Dados"
            onClick={handleGetData}
            isLoading={isRequestLoading}
            isLoadingText="Gerando..."
            isDisabled={!startDate || !endDate}
          >
            <DatabaseFillGear size={22} />
          </CustomButton>

          <CustomButton
            noMargin
            title="Gerar PDF"
            onClick={() => handleGeneratePDF(data)}
            isDisabled={data.length === 0}
          >
            <FileEarmarkPdfFill size={22} />
          </CustomButton>
        </div>
      </Row>

      {data.length > 0 && (
        <>
          <Table>
            <thead>
              <tr>
                <th colSpan="4">
                  <p>
                    Mostrando {filteredItems.length} de {data.length}
                  </p>
                </th>
              </tr>
              <tr>
                <Th
                  label="Data"
                  value="data"
                />
                <Th
                  label="Cód. Func."
                  value="cod_func_os"
                />
                <Th
                  label="Nome Func."
                  value="nomefuncionario"
                />
                <Th
                  label="Total OS"
                  value="total_os"
                />
                <Th
                  label="Total Produtos"
                  value="total_produtos"
                />
                <Th
                  label="Total Qtde"
                  value="total_qtde"
                />
                <Th
                  label="Tipo OS"
                  value="tipoos"
                />
              </tr>
            </thead>

            <tbody>
              {filteredItems.map((item) => (
                <tr>
                  <td>{formatDate(item.data)}</td>
                  <td>{item.cod_func_os}</td>
                  <td>{item.nomefuncionario}</td>
                  <td>{item.total_os}</td>
                  <td>{item.total_produtos}</td>
                  <td>{item.total_qtde}</td>
                  <td>{item.tipoos}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Paginate />
        </>
      )}
    </Container>
  )
}
